import { render, staticRenderFns } from "./OrganizationBreadcrumb.vue?vue&type=template&id=861c1c14&scoped=true&"
import script from "./OrganizationBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./OrganizationBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationBreadcrumb.vue?vue&type=style&index=0&id=861c1c14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861c1c14",
  null
  
)

export default component.exports